export default "__VITE_ASSET__CP27AHu5__"